import {
  GET_PROVEEDORES_REQUEST,
  GET_PROVEEDORES_SUCCESS,
  GET_PROVEEDORES_FAILURE,
  RESET_PROVEEDORES,
} from '../../constants/proveedores/proveedores.constants';

export const getProveedoresAction = (page, start, limit, sede, estado, tipoListado,
  busqueda = null, proveedoresSeleccionados = []) => ({
  type: GET_PROVEEDORES_REQUEST,
  payload: {
    page, start, limit, sede, estado, tipoListado, busqueda, proveedoresSeleccionados,
  },
});

export const getProveedoresSuccessAction = (datos, total, page, start, limit) => ({
  type: GET_PROVEEDORES_SUCCESS,
  payload: {
    datos, total, page, start, limit,
  },
});

export const getProveedoresFailureAction = error => ({
  type: GET_PROVEEDORES_FAILURE,
  payload: error,
});

export const resetProveedores = () => ({
  type: RESET_PROVEEDORES,
});
